import { createSlice } from '@reduxjs/toolkit'

const initialState= {
    graph1: {
        labels: [],
        allData: [],
        title: '',
        page: 0,
        pages: []
    },
    graph2: {
        labels: [],
        allData: [],
        title: '',
        page: 0,
        pages: []
    },
    graph3: {
        labels: [],
        allData: [],
        title: '',
        page: 0,
        pages: []
    },
    graph4: {
        labels: [],
        allData: [],
        title: '',
        page: 0,
        pages: []
    },
}

export const trafficSlice = createSlice({
    name: 'traffic',
    initialState,
    reducers: {
        setGraph1: (state, action) => {
            state.graph1 = action.payload
        },
        setGraph2: (state, action) => {
            state.graph2 = action.payload
        },
        setGraph3: (state, action) => {
            state.graph3 = action.payload
        },
        setGraph4: (state, action) => {
            state.graph4 = action.payload
        },
        setGraph1Data: (state, action) => {
            state.graph1.allData = action.payload
        },
        setGraph2Data: (state, action) => {
            state.graph2.allData = action.payload
        },
        setGraph3Data: (state, action) => {
            state.graph3.allData = action.payload
        },
        setGraph4Data: (state, action) => {
            state.graph4.allData = action.payload
        },

        setPage1: (state,action) => {
            state.graph1.page = action.payload
        },
        setPage2: (state,action) => {
            state.graph2.page = action.payload
        },
        setPage3: (state,action) => {
            state.graph3.page = action.payload
        },
        setPage4: (state,action) => {
            state.graph4.page = action.payload
        },
        resetTrafficSlice: (state, action) => {
            return { ...initialState };
          }
    }
})

export const { 
    setGraph1, setGraph2, setGraph3, setGraph4,
    setGraph1Data, setGraph2Data, setGraph3Data, setGraph4Data,
    setPage1, setPage2, setPage3, setPage4,resetTrafficSlice
} = trafficSlice.actions

export default trafficSlice.reducer